import React from 'react';

import { useCurrentTheme } from 'app/shared/theme';
import usePermission from 'app/shared/utils/usePermission';
import { Box, LoadingBlock } from 'app/shared/components/atoms';
import { NavigationButton } from 'app/shared/components/molecules/NavigationButton';

interface Props {
  permissionName: string;
  resourceId?: number;
  buttonsConfig: { href: string; text: string }[];
}

export const AdminHeaderControls: React.FC<React.PropsWithChildren<Props>> = ({
  permissionName,
  resourceId,
  buttonsConfig,
}) => {
  const { colors } = useCurrentTheme();
  const hasViewHeaderPermission = usePermission(permissionName, resourceId);

  if (!hasViewHeaderPermission) {
    return null;
  }

  if (buttonsConfig.length === 0) {
    return <LoadingBlock w="100%" h="80px" />;
  }

  return (
    <Box
      data-qaid="admin-header-controls"
      backgroundColor={colors.primary.black.base}
      p={5}
      justifyContent="center"
      gap={5}
      flexWrap="wrap"
    >
      {buttonsConfig.map((buttonConfig) => (
        <NavigationButton
          key={buttonConfig.text}
          href={buttonConfig.href}
          openInNewTab={true}
        >
          {buttonConfig.text}
        </NavigationButton>
      ))}
    </Box>
  );
};
